export type ProductData = {
  // Core product information
  productName: string;
  productId: string;
  productMainImageUrl: string;
  entityType: 'product' | 'pattern' | 'article';
  legacyId: string;
  variantId: string;

  // Pattern-specific fields
  isFreePattern: string; // 'true' | 'false' as string from HTML
  pointCost: string; // Points cost as string from HTML

  // Product metadata
  metaSubtitle: string;
  metaYarnComposition: string;
  metaYarnWeightCategory: string;

  // Offer/timing information
  offerEndDate: string;

  // Additional fields that might be present in dataset
  [key: string]: string | undefined;
};

let didReadProductData = false;

// Default values
let productData: Partial<ProductData> = {
  entityType: 'product'
};

export const getProductDataFromHTML = (): Partial<ProductData> => {
  const productDataWrapper = document.getElementById('product-data');

  if (!productDataWrapper) {
    console.warn(
      'Could not read product data from DOM, missing #product-data element'
    );
    return productData;
  }

  if (didReadProductData) return productData;

  // Map dataset from DOM with default values
  productData = {
    ...productData,
    ...productDataWrapper.dataset
  };

  didReadProductData = true;

  return productData;
};
